import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoundButton from 'features/shared/components/buttons/RoundButton';
import DateFormatter from 'features/shared/components/formatters/DateFormatter';
import CommodityIcon from 'features/shared/components/icons/CommodityIcon';
import React from 'react';
import ContractSimplifiedDTO from '../dtos/ContractSimplifiedDTO';
import ContractStatusLabel from './ContractStatusLabel';
import { getContractDetailRoute } from 'features/shared/helpers/routeHelper';
import { getTerminationDate } from 'features/shared/helpers/dateHelper';
import { useTranslation } from 'react-i18next';

interface Props {
  contract: ContractSimplifiedDTO;
}

const FuelingContractSimplified = ({ contract }: Props) => {
  // translations
  const tTerms = useTranslation("shared\\terms").t;

  // sub-renders
  const renderSignatureDate = () => {
    if (contract.signitureDate) {
      return (
        <span className="mt-sm-n1">
          <span className="mr-1 text-muted">
            <FontAwesomeIcon icon="file-signature" size="xs" fixedWidth />
          </span>
          <span className="small">
            <DateFormatter date={contract.signitureDate} />
          </span>
        </span>
      );
    } 
  }

  const renderTerminationDate = () => {
    if (contract.terminationDatePresentation) {
      return (
        <span className="mt-sm-n1">
          <span className="mr-1 text-muted">
            <FontAwesomeIcon icon="calendar-times" size="xs" fixedWidth />
          </span>
          <span className="small">
            {getTerminationDate(contract, tTerms)}
          </span>
        </span>
      );
    } 
  }

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        <div className="row no-gutters align-items-center">
          <div className="col-sm-5 col-lg-4">
            <div className="d-flex">
              <CommodityIcon commodityDetail={contract.commodityDetail!} includeColor isProduction={contract.isProduction} />
              <div className="ml-2 text-truncate" title={contract.contractNumber}>
                {contract.contractNumber}
              </div>
            </div>
          </div>
          <div className="col-sm-7 col-lg-8">
            <div className="row no-gutters align-items-center">
              <div className="col col-sm-7 col-lg-6 order-1 pl-2 pl-sm-0">
                <div className="d-flex flex-wrap flex-sm-column">
                  {renderSignatureDate()}
                  {renderTerminationDate()}
                </div>
              </div>  
              <div className="col-auto col-sm-5 col-lg-6 order-0 order-sm-1">
                <ContractStatusLabel status={contract.contractStatus!} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-auto pl-2 pl-sm-3">
        <RoundButton 
          to={getContractDetailRoute(contract.contractId!, true)} 
          asLink 
        />
      </div>
    </div>
  )
}

export default FuelingContractSimplified;
